module.exports = __webpack_public_path__ + "static/media/ICARIUS_LOGIN_2.fcd92886.jpeg";